/**
 * @Author: v_jppjpeng
 * @Date: 2024-09-03 21:19:27
 * @Explain: 分组列表 - 子集
 */
import { useEffect, useState } from 'react';
import Icon from '../icon';

type PropsType = {
  children: any;
  title: any;
  /** 是否打开展开收起 */
  isExpanded?: boolean;
  /** 是否默认展开收起 */
  defaultExpanded?: boolean;
  /** 折叠项点击事件 */
  onClick?: () => void;
};

function GroupItem(props: PropsType) {
  const {
    children,
    title,
    defaultExpanded = false,
    isExpanded = false,
    onClick,
  } = props;
  const [expanded, setIsExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (!isExpanded) {
      setIsExpanded(true);
    }
  }, [isExpanded]);
  return (
    <>
      {title && (
        <div
          className="group-expanded-title"
          onClick={() => {
            if (isExpanded) {
              setIsExpanded((val) => !val);
              onClick?.();
            }
          }}
        >
          {isExpanded && (
            <Icon.Font
              name={expanded ? 'triangle-down-arrow' : 'triangle-right-arrow'}
              fontSize={20}
            />
          )}
          {title}
        </div>
      )}

      {expanded && children}
    </>
  );
}

export default GroupItem;
